import {get} from "lodash";
import {IPlayer} from "modules/types";
import {PlayerPoolFilterStats, PlayerPositionEnum} from "modules/enums";
import {IPlayerStatsItem} from "./playerStats";

const tacklesKey = "player_pool.stats.tackles";
const sacksKey = "player_pool.stats.sk";

export const getPoolStats = (player: IPlayer) => {
	const stats = {
		[PlayerPositionEnum.QB]: [
			{value: player.stats.passingTouchdowns, key: "player_pool.stats.pass_tds"},
			{value: player.stats.passingYards, key: "player_pool.stats.pass_yds"},
		],
		[PlayerPositionEnum.RB]: [
			{value: player.stats.rushingTouchdowns, key: "player_pool.stats.rush_tds"},
			{
				value: player.stats.rushingYards,
				key: "player_pool.stats.rush_yds",
			},
			{value: player.stats.receivingTouchdowns, key: "player_pool.stats.rec_tds"},
			{
				value: player.stats.receivingYards,
				key: "player_pool.stats.rec_yds",
			},
		],
		[PlayerPositionEnum.WR]: [
			{
				value: player.stats.receivingYards,
				key: "player_pool.stats.rec_yds",
			},
			{value: player.stats.receivingTouchdowns, key: "player_pool.stats.rec_tds"},
		],
		[PlayerPositionEnum.LB]: [
			{value: player.stats.tackles, key: tacklesKey},
			{value: player.stats.tacklesForLoss, key: "player_pool.stats.tfl"},
			{value: player.stats.sacks, key: sacksKey},
			{value: player.stats.interceptions, key: "player_pool.stats.int"},
		],
		[PlayerPositionEnum.DB]: [
			{value: player.stats.tackles, key: tacklesKey},
			{value: player.stats.interceptions, key: "player_pool.stats.int"},
			{value: player.stats.sacks, key: sacksKey},
			{value: player.stats.tacklesForLoss, key: "player_pool.stats.tfl"},
		],
		[PlayerPositionEnum.DL]: [
			{value: player.stats.tackles, key: tacklesKey},
			{value: player.stats.sacks, key: sacksKey},
		],
		[PlayerPositionEnum.OL]: [
			{value: player.stats.gamesPlayed, key: "player_pool.stats.gp"},
			// {value: player.stats.gamesStarted, key: "player_pool.stats.gs"},
		],
		[PlayerPositionEnum.K]: [
			{value: player.stats.fieldGoalsMade, key: "player_pool.stats.fgm"},
			{value: player.stats.fieldGoalsPct, key: "player_pool.stats.fg%", isShowDecimal: true},
		],
		[PlayerPositionEnum.P]: [
			{value: player.stats.puntYards, key: "player_pool.stats.punt_yds"},
			{
				value: player.stats.averageYards,
				key: "player_pool.stats.avg_yds",
				isShowDecimal: true,
			},
		],
		[PlayerPositionEnum.ST]: [
			{value: player.stats.returnsTouchdowns, key: "player_pool.stats.ret_tds"},
			{value: player.stats.specialTeamsTackles, key: "player_pool.stats.st_tk"},
		],
	};

	return stats[player.position] as IPlayerStatsItem[];
};

const stats = {
	[PlayerPositionEnum.QB]: [
		PlayerPoolFilterStats.PassTouchdowns,
		PlayerPoolFilterStats.PassYards,
	],
	[PlayerPositionEnum.RB]: [
		PlayerPoolFilterStats.RushingTouchdowns,
		PlayerPoolFilterStats.RushingYards,
		PlayerPoolFilterStats.ReceivingTouchdowns,
		PlayerPoolFilterStats.ReceivingYards,
	],
	[PlayerPositionEnum.WR]: [
		PlayerPoolFilterStats.ReceivingYards,
		PlayerPoolFilterStats.ReceivingTouchdowns,
	],
	[PlayerPositionEnum.LB]: [
		PlayerPoolFilterStats.DefensiveTackles,
		PlayerPoolFilterStats.DefensiveTacklesForLoss,
		PlayerPoolFilterStats.Sacks,
		PlayerPoolFilterStats.Interceptions,
	],
	[PlayerPositionEnum.DB]: [
		PlayerPoolFilterStats.DefensiveTackles,
		PlayerPoolFilterStats.Interceptions,
		PlayerPoolFilterStats.Sacks,
		PlayerPoolFilterStats.DefensiveTacklesForLoss,
	],
	[PlayerPositionEnum.DL]: [PlayerPoolFilterStats.DefensiveTackles, PlayerPoolFilterStats.Sacks],
	[PlayerPositionEnum.OL]: [PlayerPoolFilterStats.GamesPlayed],
	[PlayerPositionEnum.K]: [
		PlayerPoolFilterStats.FieldGoalsMade,
		PlayerPoolFilterStats.FieldGoalPercentage,
	],
	[PlayerPositionEnum.P]: [
		PlayerPoolFilterStats.PuntYards,
		PlayerPoolFilterStats.AveragePuntYards,
	],
	[PlayerPositionEnum.ST]: [
		PlayerPoolFilterStats.ReturnTouchdowns,
		PlayerPoolFilterStats.SpecialTeamsTackles,
	],
};

export const getIsDisabledStatByPosition = (
	position: PlayerPositionEnum | number,
	stat: PlayerPoolFilterStats
) => {
	if (!position) {
		return false;
	}

	return !get(stats, position as PlayerPositionEnum, [] as PlayerPoolFilterStats[]).includes(
		stat
	);
};
